import { Box } from '@chakra-ui/react';
import React from 'react';

const ExpandDown = () => {
    return (
        <Box>
            <svg width='24px' height='24px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M18 9L12 15L6 9' stroke='#222222' />
            </svg>
        </Box>
    );
};

export default ExpandDown;
